import { render } from "./ListConcept.vue?vue&type=template&id=bcef227e&scoped=true"
import script from "./ListConcept.vue?vue&type=script&lang=js"
export * from "./ListConcept.vue?vue&type=script&lang=js"

import "./ListConcept.vue?vue&type=style&index=0&id=bcef227e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcef227e"]])

export default __exports__